import {Extensions, IExtensionInstance} from '@baidu/realtime-editor';
import PlaceHolderImg from '@/assets/img/flexBuilderPlaceHolder.png';
import {renderCompFactory, RenderInlineComp} from './render';
import BtnFlexBuilder from './icon/btn-flex-builder';
// import BtnCustom from './icon/btn-custom.svg?tsx';
// import BtnCommentAndPrize from './icon/btn-comment-and-prize.svg?tsx';
// import BtnWordCloud from './icon/btn-word-cloud.svg?tsx';
// import BtnChart from './icon/btn-chart.svg?tsx';
import {createOnInsertResult} from './utils';
import {dataBus} from './render/data-bus';
import {utils as KuUtils} from '@/kuTools/sdk/utils';
import {FlexBuilderType, FlexBuilderTypeToNodeTypeMap, LogIdMap, LogIdMapForBackend} from './constant';
import {createBuilder} from './render/request';
import {doc} from '@/kuTools/sdk/doc';
import {flexBuilderClipboard, flexBuilderPaste} from './utils';

const EntryIcon = () => {
    return <BtnFlexBuilder />;
};

/** 创建占位图 dom */
const createPlaceholderDOM = () => {
    const img = document.createElement('img');
    img.src = PlaceHolderImg;
    img.style.width = '100%';
    img.style.maxWidth = '500px';
    return img;
};
const placeholderDOM = createPlaceholderDOM();

export const createOnInsertResultWithBuilderId = async (
    type: 'custom' | 'template',
    templateId = '',
    flexBuilderType = FlexBuilderType.frontend
) => {
    // 点击入口时就创建好 builder id，主要是为了解决 undo redo 问题
    // eslint-disable-next-line max-len
    // https://console.cloud.baidu-int.com/devops/icafe/issue/so-kldoc-30445/show?source=copy-shortcut
    let builderId = '';
    try {
        const docGuid = doc.getDocId();
        const res = await createBuilder({docGuid, templateId, flexBuilderType});
        builderId = res?.builderId;
    } catch (error) {
        console.error(error);
    }

    if (!builderId) {
        // 如果创建 builder 失败，则在组件渲染时再尝试请求创建一次
        dataBus.setData(templateId);
        return createOnInsertResult(
            type,
            undefined,
            undefined,
            flexBuilderType
        );
    }
    return createOnInsertResult(type, builderId, undefined, flexBuilderType);
};

export const pluginFactory = ({
    viewNode,
    insert,
    flexBuilderType,
}: {
    viewNode: {
        title: string;
        getQuote: () => string;
    };
    insert: {
        title: string;
        keywords: string[];
        tip: () => JSX.Element;
        hook: (config: IExtensionInstance['insert'], utils: any) => void;
        toolbar: {
            enable: () => boolean;
        };
    };
    flexBuilderType: FlexBuilderType;
}) => {
    const {title: viewNodeTitle, getQuote} = viewNode;
    const {title, keywords, tip, hook, toolbar} = insert;
    const nodeType = FlexBuilderTypeToNodeTypeMap[flexBuilderType];

    const Extension = Extensions.createViewNode({
        type: nodeType,
        render: {
            renderView: renderCompFactory(flexBuilderType),
            renderStaticView: RenderInlineComp,
        },
        comment: {
            getQuote,
        },
        // @ts-ignore TODO: 暂时 as any 解决 morpho 构建产物没有 title 的类型声明的问题
        title: viewNodeTitle,
    });

    return Extensions.createVoidCardPlugin({
        nodes: [Extension],
        // TODO: utils: InsertUtils 类型声明需要 RTE 暴露
        insert: (utils: any) => {
            const config: IExtensionInstance['insert'] = {
                title,
                tip,
                keywords,
                tag: true,
                toolbar: {
                    enable: toolbar.enable,
                    guide: nodeType,
                },
                icon: EntryIcon,
                className: 'flex-builder-entry',
                onInsert: async () => {
                    KuUtils.kuLogger({
                        repId: flexBuilderType === FlexBuilderType.backend
                            ? LogIdMapForBackend.CreateCustomInit
                            : LogIdMap.CreateCustomInit,
                        params: {from: utils.from},
                    });
                    return createOnInsertResultWithBuilderId(
                        'custom',
                        undefined,
                        flexBuilderType
                    );
                },
                priority: 'first',
                // TODO: MVP 版本，暂时不开放模板入口
                // children: [
                //     {
                //         title: '自定义',
                //         type: 'button',
                //         icon: () => (<BtnCustom />),
                //         keywords: ['zdy', '自定义', 'zidingyi'],
                //         onInsert: async () => {
                //             KuUtils.kuLogger({
                //                 repId: LogIdMap.CreateCustomInit,
                //                 params: {from: utils.from},
                //             });
                //             return createOnInsertResultWithBuilderId('custom');
                //         },
                //     },
                //     {
                //         type: 'divider',
                //     },
                //     {
                //         title: '评论抽奖',
                //         type: 'button',
                //         icon: () => (<BtnCommentAndPrize />),
                //         keywords: ['plcj', '评论抽奖', 'pinglunchoujiang'],
                //         onInsert: async () => {
                //             // TODO: 模板数据 在上线前确认 @zhupoyan
                //             const templateId = '_PDfTB1OkApVGt';
                //             const templateName = '评论抽奖';

                //             KuUtils.kuLogger({
                //                 repId: LogIdMap.CreateComponentByTemplate,
                //                 params: {
                //                     from: utils.from,
                //                     templateId,
                //                     templateName,
                //                 },
                //             });

                //             return createOnInsertResultWithBuilderId('template', templateId);
                //         },
                //     },
                //     {
                //         title: '词云图生成',
                //         type: 'button',
                //         icon: () => (<BtnWordCloud />),
                //         keywords: ['cytsc', '词云图生成', 'ciyuntushengcheng'],
                //         onInsert: async () => {
                //             // TODO: 模板数据 在上线前确认 @zhupoyan
                //             const templateId = 'a72SaOhLSlYsCD';
                //             const templateName = '词云图生成';

                //             KuUtils.kuLogger({
                //                 repId: LogIdMap.CreateComponentByTemplate,
                //                 params: {
                //                     from: utils.from,
                //                     templateId,
                //                     templateName,
                //                 },
                //             });

                //             return createOnInsertResultWithBuilderId('template', templateId);
                //         },
                //     },
                //     {
                //         title: '图表生成',
                //         type: 'button',
                //         icon: () => (<BtnChart />),
                //         keywords: ['tbsc', '图表生成', 'tubiaoshengcheng'],
                //         onInsert: async () => {
                //             // TODO: 模板数据 在上线前确认 @zhupoyan
                //             const templateId = 'umqunScVV2BM8X';
                //             const templateName = '图表生成';

                //             KuUtils.kuLogger({
                //                 repId: LogIdMap.CreateComponentByTemplate,
                //                 params: {
                //                     from: utils.from,
                //                     templateId,
                //                     templateName,
                //                 },
                //             });

                //             return createOnInsertResultWithBuilderId('template', templateId);
                //         },
                //     },
                // ],
            };
            hook?.(config, utils);
            return false;
        },
        hooks: {
            onPaste: (node: any) => {
                if (node?.type !== nodeType) {
                    return;
                }
                flexBuilderPaste.add(node?.builderId);
                // 此处用于chrome debug浏览器插件数据调试，同环境复制随心搭直接通过服务端接口创建，跨环境复制随心搭则通过node._builderData上的数据创建新随心搭
                // 如果是同环境复制，这里可删掉_builderData，利用服务端提供的随心搭复制能力即可
                if (node._sourceHost === location.hostname) {
                    delete node._builderData;
                }
            },
            onPrint: () => {
                return placeholderDOM;
            },
            onMaterialInsert: (node) => {
                // 从模板库拖拽含有随心搭组件的内容进正文后，会触发该钩子函数，此时需要标记一下节点，触发组件的重新创建 builder id 的流程
                if (node && node.type === nodeType) {
                    flexBuilderPaste.add(node?.builderId);
                }
            },
            onCopy: (node, isCut) => {
                if (node?.type !== nodeType) {
                    return;
                }

                if (isCut) {
                    flexBuilderClipboard.set(node.builderId);
                } else {
                    flexBuilderClipboard.clear();
                }
            },
        },
        drag: {
            dragRender: () => {
                return placeholderDOM;
            },
            dragSelector: '.fb-iframe-shadow-drag',
        },
    });
};
